import jwt_decode from 'jwt-decode';

export const decodeAuthToken = (token) => {
    try {
        return jwt_decode(token);
    } catch (error) {
        console.error('Error al decodificar el token:', error);
        return null;
    }
};